// extracted by mini-css-extract-plugin
module.exports = {"offertaModal":"OffertaModal_offertaModal__ein2u","formWrapper":"OffertaModal_formWrapper___2gch","image":"OffertaModal_image__Ad_jb","text":"OffertaModal_text__Bs5qa"};